"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchNotifications = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const lodash_es_1 = require("lodash-es");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const useFetchNotifications = () => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    const { current } = (0, frontend_infra_localisation_1.useI18n)();
    return async (options) => {
        const { orderBy = 'createdAt', page = 1, pageSize = 100, orderByDesc = true, selectedId, type = [], status = [], startDate, endDate, } = options;
        const query = {
            orderBy,
            page,
            pageSize,
            orderByDesc,
            language: current,
        };
        const queryParams = new URLSearchParams((0, lodash_es_1.mapValues)(query, (value) => String(value)));
        const typeFilters = type;
        if (typeFilters.length) {
            typeFilters.forEach((param) => {
                queryParams.append('type', param);
            });
        }
        const statusFilters = status;
        if (statusFilters.length) {
            statusFilters.forEach((param) => {
                queryParams.append('status', param);
            });
        }
        if (startDate) {
            queryParams.append('startDate', startDate);
        }
        if (endDate) {
            queryParams.append('endDate', endDate);
        }
        let url = `${config.NOTIFICATION_CENTER_ENDPOINT}/user-notifications?${queryParams.toString()}`;
        if (selectedId) {
            url = `${url}&selectedId=${selectedId}`;
        }
        const response = await ui_platform_http_1.HttpBaseApi.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    };
};
exports.useFetchNotifications = useFetchNotifications;
//# sourceMappingURL=useFetchNotifications.js.map